import { Microfrontend } from '@cian/mf-react';
import { ICianMFUIElement } from '@cian/mf-registry/browser';
import { useEffect, useRef } from 'react';
import { IWidgetManifest } from '../../../types/widgetManifest';
import { useApplicationContext } from '../../../utils/applicationContext';
import { useSelector } from 'react-redux';
import { selectTrackingInfo } from '../../../selectors/user';
import { trackSuccessAuth } from '../../../utils/tracking/tracking';

export const MpAuthContainer = () => {
  const { config, logger } = useApplicationContext();
  const user = useSelector(selectTrackingInfo);
  const mfRef = useRef<ICianMFUIElement | null>(null);

  useEffect(() => {
    const handleUserAuth = () => {
      trackSuccessAuth(user);
      window.location.reload();
    };

    // Сохраняем ссылку на ноду из ref.current, чтобы правильно убрать eventListener (иначе ругается линтер)
    const cleanupCurrent = mfRef.current;

    cleanupCurrent?.addEventListener('user-auth', handleUserAuth);

    return () => {
      cleanupCurrent?.removeEventListener('user-auth', handleUserAuth);
    };
  }, [user, logger]);

  const manifest = config.get<IWidgetManifest>('mpAuthManifest');

  if (!manifest) {
    logger.error('Отсутствует манифест виджета авторизации', {
      domain: 'microfrontends.mp-auth.manifest',
    });

    return null;
  }

  return <Microfrontend ref={mfRef} {...manifest} />;
};
